import './ControllerInfoPage.scss';

import { IonButton, IonContent, IonPage } from '@ionic/react';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { ControllerSummaryCard } from 'src/components/controller-details/ControllerSummaryCard';
import DesktopDetailPageHeader from 'src/components/reusable-components/desktop-header/DesktopDetailPageHeader';
import MobileDetailPageHeader from 'src/components/reusable-components/mobile-detail-page-header/MobileDetailPageHeader';
import { ControllerMessages } from 'src/intl/ControllerMessages';
import { selectBleConnectedDevice } from 'src/redux/ble/selectors';
import { useSocketGet } from 'src/utils/socket';
import { SocketContextSentinel } from 'src/utils/socket/context/sentinelSocketContext';
import { ControllerInfoBundleList } from './ControllerInfoBundleList';
import { useHasBluetoothLE, useIsMobile } from 'src/utils/helpers/platformHelpers';
import { HomeMessages } from 'src/intl/HomeMessages';
import { bleActions } from 'src/redux/ble/actions';
import { useGA4 } from '../../utils/ga4';

export const ControllerInfoPage: FC = () => {
  document.title = 'Controller Detail';
  useGA4();

  const params = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const isMobile = useIsMobile();
  const hasBluetooth = useHasBluetoothLE();

  const { item: controller } = useSocketGet(SocketContextSentinel, 'controllers', params.id);
  const connectedController = useSelector(selectBleConnectedDevice);
  const hasConnectedControllerInfo =
    connectedController && controller && controller.ssn === connectedController.serialNumber;

  return (
    <IonPage>
      {isMobile ? (
        <MobileDetailPageHeader title={formatMessage(ControllerMessages.controllersHeader)} />
      ) : (
        <DesktopDetailPageHeader left heading={formatMessage(ControllerMessages.controllersHeader)} />
      )}
      <IonContent className="controller-info-content">
        {!connectedController && hasBluetooth && (
          <IonButton
            className="ion-margin-vertical"
            expand="block"
            onClick={e => {
              e.stopPropagation();
              dispatch(bleActions.openConnectControllerModal());
            }}
          >
            {formatMessage(HomeMessages.connectToController)}
          </IonButton>
        )}
        {controller && <ControllerSummaryCard controller={controller} />}
        {hasConnectedControllerInfo && <ControllerInfoBundleList />}
      </IonContent>
    </IonPage>
  );
};
